import { useQuery } from '@tanstack/vue-query'
import { adminApi as api } from '@core/api/httpClient'
import { investorsQueryKeys } from '../investorsQueryKeys'
import { INVESTORS } from '../investorsEndpointPaths'

interface OnboardingReviewStatusCounts {
  pendingReview: number
}

async function getOnboardingReviewStatusCounts(): Promise<OnboardingReviewStatusCounts> {
  const { data } = await api.get<
    OnboardingReviewStatusCounts | { data: OnboardingReviewStatusCounts }
  >(`${INVESTORS}/onboarding-review/status-counts`)
  const result = 'data' in data ? data.data : data
  return { pendingReview: Number(result?.pendingReview ?? 0) }
}

export function useOnboardingReviewStatusCountsQuery() {
  return useQuery({
    queryKey: [...investorsQueryKeys.all, 'onboardingReview', 'statusCounts'] as const,
    queryFn: getOnboardingReviewStatusCounts,
    staleTime: 1000 * 30,
  })
}
